<template>
  <div class="Single-white">
    <div class="item-header">基本信息</div>
    <table class="item-content" v-if="option == 0">
      <tr>
        <td class="dialog-title">
          学号
        </td>
        <td class="dialog-cnt">
          {{ BUser.UserID }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          姓名
        </td>
        <td class="dialog-cnt">
          {{ BUser.RealName }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          性别
        </td>
        <td class="dialog-cnt">
          {{ BUser.Sex == 1 ? '男' : '女' }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          出生日期
        </td>
        <td class="dialog-cnt">
          {{ BUser.Birthday }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          个人电话号码
        </td>
        <td class="dialog-cnt">
          {{ BUser.Phone }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          学院
        </td>
        <td class="dialog-cnt">
          {{ BUser.Academy }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          专业
        </td>
        <td class="dialog-cnt">
          {{ BUser.Specialty }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          班级
        </td>
        <td class="dialog-cnt">
          {{ BUser.DeptName }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">入学年份</td>
        <td class="dialog-cnt">
          {{ BUser.TheEntranceDate }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">年级</td>
        <td class="dialog-cnt">
          {{ BUser.EntryDate }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">身份证号</td>
        <td class="dialog-cnt">
          {{ BUser.IDCard }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人姓名</td>
        <td class="dialog-cnt">
          {{ BUser.TheGuardian }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人电话号码</td>
        <td class="dialog-cnt">
          {{ BUser.TheGuardianPhone }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人身份</td>
        <td class="dialog-cnt">
          {{ TheGuardianRelationShipValue
          }}<span v-if="BUser.Bak19 != undefined && BUser.Bak19 != ''"
            >（{{ BUser.Bak19 }}）</span
          >
        </td>
      </tr>
      <tr>
        <td class="dialog-title">学生类型</td>
        <td class="dialog-cnt">
          {{ BUser.Degree }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">是否是贫困生</td>
        <td class="dialog-cnt">
          {{ BUser.Bak20 == '1' ? '是' : BUser.Bak20 == '0' ? '否' : '' }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">生源地</td>
        <td class="dialog-cnt">
          {{ BUser.NativePlace }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">民族</td>
        <td class="dialog-cnt">
          {{ BUser.NationValue }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">国籍</td>
        <td class="dialog-cnt">
          {{ BUser.NationalityValue }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">学籍异动</td>
        <td class="dialog-cnt">
          {{ BUser.Bak18 }}
        </td>
      </tr>
    </table>

    <table class="item-content" v-if="option == 1">
      <tr>
        <td class="dialog-title">
          <span class="must-tip">*</span>
          学号
        </td>
        <td class="dialog-cnt">
          {{ BUser.UserID }}
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          <span class="must-tip">*</span>
          姓名
        </td>
        <td class="dialog-cnt">
          <el-input v-model="BUser.RealName" maxlength="20"></el-input>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          <span class="must-tip">*</span>
          性别
        </td>
        <td class="dialog-cnt">
          <el-radio v-model="BUser.Sex" label="1">男</el-radio>
          <el-radio v-model="BUser.Sex" label="0">女</el-radio>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          <span class="must-tip">*</span>
          出生日期
        </td>
        <td class="dialog-cnt">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            v-model="BUser.Birthday"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          <span class="must-tip">*</span>
          个人电话号码
        </td>
        <td class="dialog-cnt">
          <el-input v-model="BUser.Phone" maxlength="20"></el-input>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">
          <span class="must-tip">*</span>
          学院
        </td>
        <td class="dialog-cnt">
          <el-cascader
            ref="wcascader"
            v-model="Classed"
            @change="DeptIDChange"
            @expand-change="bumen"
            :options="data"
            :props="{ checkStrictly: true }"
            clearable
            placeholder="请选择"
          >
          </el-cascader>
        </td>
      </tr>
      <tr>
        <td class="dialog-title"><span class="must-tip">*</span>专业</td>
        <td class="dialog-cnt">
          <el-select
            v-model="BUser.SpecialtyID"
            placeholder="请选择专业"
            @change="ClassSelect"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in SpecialtyList"
              v-bind:key="index"
            >
            </el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title"><span class="must-tip">*</span>班级</td>
        <td class="dialog-cnt">
          <el-select v-model="BUser.DeptID" placeholder="请选择班级">
            <el-option
              v-for="(item, index) in ClassList"
              :label="item.label"
              :value="item.value"
              v-bind:key="index"
            >
            </el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">入学年份</td>
        <td class="dialog-cnt">
          <el-select
            v-model="BUser.TheEntranceDate"
            placeholder="请选择入学年份"
          >
            <el-option
              :label="item"
              :value="item"
              v-for="(item, index) in YearList"
              v-bind:key="index"
            ></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">年级</td>
        <td class="dialog-cnt">
          <el-select v-model="BUser.EntryDate" placeholder="请选择年级">
            <el-option
              :label="item.CDicValue"
              :value="item.CDicValue"
              v-for="(item, index) in GradeList"
              v-bind:key="index"
            ></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">身份证号</td>
        <td class="dialog-cnt">
          <el-input v-model="BUser.IDCard" maxlength="18"></el-input>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人姓名</td>
        <td class="dialog-cnt">
          <el-input v-model="BUser.TheGuardian" maxlength="20"></el-input>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人电话号码</td>
        <td class="dialog-cnt">
          <el-input v-model="BUser.TheGuardianPhone" maxlength="20"></el-input>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">监护人身份</td>
        <td class="dialog-cnt">
          <el-select
            v-model="TheGuardianRelationShipValue"
            placeholder="请选择监护人身份"
          >
            <el-option
              :label="item.CDicValue"
              :value="item.CDicValue"
              v-for="(item, index) in RelativeList"
              v-bind:key="index"
            ></el-option>
          </el-select>
          <el-input
            v-model="BUser.Bak19"
            maxlength="20"
            v-if="TheGuardianRelationShipValue == '其他'"
          ></el-input>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">学生类型</td>
        <td class="dialog-cnt">
          <el-select v-model="BUser.Degree" placeholder="请选择学生类型">
            <el-option
              :label="item.CDicValue"
              :value="item.CDicValue"
              v-for="(item, index) in DegreeList"
              v-bind:key="index"
            ></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">是否是贫困生</td>
        <td class="dialog-cnt">
          <el-select v-model="BUser.Bak20" placeholder="请选择是否是贫困生">
            <el-option label="是" value="1" key="1"></el-option>
            <el-option label="否" value="0" key="0"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">生源地</td>
        <td class="dialog-cnt">
          <el-cascader
            ref="myProvinCas"
            v-model="BUser.NativePlaceList"
            placeholder="省/市/区"
            :options="PlaceList"
            :props="{ value: 'label' }"
          ></el-cascader>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">民族</td>
        <td class="dialog-cnt">
          <el-select v-model="BUser.Nation" placeholder="请选择民族">
            <el-option
              :label="item.CDicValue"
              :value="item.DicKey"
              v-for="(item, index) in NationList"
              v-bind:key="index"
            ></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">国籍</td>
        <td class="dialog-cnt">
          <el-select v-model="BUser.Nationality" placeholder="请选择国籍">
            <el-option
              :label="item.CDicValue"
              :value="item.DicKey"
              v-for="(item, index) in NationalityList"
              v-bind:key="index"
            ></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td class="dialog-title">学籍异动</td>
        <td class="dialog-cnt">
          <el-select v-model="BUser.Bak18" placeholder="请选择学籍异动">
            <el-option
              :label="item.CDicValue"
              :value="item.CDicValue"
              v-for="(item, index) in StudentList"
              v-bind:key="index"
            ></el-option>
          </el-select>
        </td>
      </tr>
    </table>

    <tableconfig
      ref="tableconfig"
      class="table-config"
      :isTableNameVisible="false"
      @dialogHandleClose="handleClose"
    />
  </div>
</template>
<script>
import { regionData } from 'element-china-area-data';
import tableconfig from '../../components/my-table-config.vue';

export default {
  components: {
    tableconfig,
  },
  name: 'UserBasic',
  data() {
    return {
      option: 0, //当前操作状态0表示查看，1表示编辑
      GeneralID: '',
      BUser: {},
      YearList: [],
      TableConfig: {},
      DeptData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24 + 8.64e7;
        },
      },
      PlaceList: regionData,
      TheGuardianRelationShipValue: '',
      SpecialtyList: [],
      StudentList: [],
      ClassList: [],
      DegreeList: [],
      GradeList: [],
      NationList: [],
      NationalityList: [],
      RelativeList: [],
      DeptID: '',
      data: [],
      Classed: ['DeptID01'],
    };
  },
  methods: {
    Selected_to_shut_dow(dt) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi &&
          NodeList[i].children.length > 0 &&
          NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break;
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (
          this.data[i].fuzi &&
          this.data[i].children.length > 0 &&
          this.data[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }

      let _this = this;
      if (
        obj.fuzi &&
        obj.children.length > 0 &&
        obj.children[0].DeptID == '-1'
      ) {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
          DeptID: dt[dt.length - 1],
          content: '',
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },

    handleClose(done) {
      this.$emit('fatherSetOption', 0);
    },
    SetOption: function(state) {
      this.option = state;
      this.$refs.tableconfig.setOptionState(this.option);
    },
    SetUserInfo: function(citem, parm) {
      this.GeneralID = parm.ID;
      this.BUser = citem.UserBasic;
      this.Classed.push(this.BUser.AcademyID);
      this.TableConfig = citem.TableConfig;
      this.$refs.tableconfig.setTableConfig({
        TableConfig: this.TableConfig,
        OptionState: parm.OptionState,
      });
      for (let i = 0; i < this.RelativeList.length; i++) {
        if (this.BUser.TheGuardianRelationShip == this.RelativeList[i].DicKey) {
          this.TheGuardianRelationShipValue = this.RelativeList[i].CDicValue;
          break;
        }
      }
      this.DeptIDChange(this.BUser.AcademyID, 'T');
      this.ClassSelect('T');
    },
    SavaUserData: function() {
      this.$refs.tableconfig.exportData();
    },
    ClassSelect(is) {
      let _this = this;
      this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
        DeptID: _this.BUser.SpecialtyID,
        content: '',
        DeptType: 4,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          if (is != 'T') {
            _this.BUser.DeptID = '';
          }

          _this.ClassList = [];
          if (res.Data.length > 0) {
            for (let index = 0; index < res.Data.length; index++) {
              let key = {
                value: res.Data[index].value,
                label: res.Data[index].label,
              };
              _this.ClassList.push(key);
            }
          }
        }
      });
    },
    DeptIDChange(acaID, is) {
      let _this = this;
      if (acaID.length < 4) {
        acaID = acaID[acaID.length - 1];
      }

      if (_this.Classed.length > 1) {
        this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
          DeptID: acaID,
          content: '',
          DeptType: 3,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            if (is != 'T') {
              _this.BUser.SpecialtyID = '';
              _this.BUser.DeptID = '';
            }
            _this.SpecialtyList = [];
            if (res.Data.length > 0) {
              for (let index = 0; index < res.Data.length; index++) {
                let key = {
                  value: res.Data[index].value,
                  label: res.Data[index].label,
                };
                _this.SpecialtyList.push(key);
              }
            }
          }
        });
      }
    },

    CheckSumDataState() {
      let result = true;
      if (this.BUser.UserID == '') {
        result = false;
        this.Global.request_failure('请输入学号');
      } else if (this.BUser.RealName == '') {
        result = false;
        this.Global.request_failure('请输入姓名');
      } else if (
        this.BUser.Phone != undefined &&
        this.BUser.Phone != '' &&
        !this.Global.checkMobile(this.BUser.Phone)
      ) {
        result = false;
        this.Global.request_failure('个人电话号码格式错误');
      } else if (
        this.BUser.IDCard != undefined &&
        this.BUser.IDCard != '' &&
        !this.Global.isCardID(this.BUser.IDCard)
      ) {
        result = false;
        this.Global.request_failure('身份证格式错误');
      }
      return result;
    },
    SubmitUserData: function(obj) {
      if (this.BUser.DeptID instanceof Array) {
        this.BUser.DeptID = this.BUser.DeptID[this.BUser.DeptID.length - 1];
      }
      this.TableConfig = obj;
      if (this.CheckSumDataState()) {
        let _this = this;
        for (let i = 0; i < _this.RelativeList.length; i++) {
          if (
            _this.RelativeList[i].CDicValue == _this.TheGuardianRelationShipValue
          ) {
            _this.BUser.TheGuardianRelationShip = _this.RelativeList[i].DicKey;
            break;
          }
        }
        this.$Http_Post('ReportCriData/SubmitUserTableConfig', {
          GeneralID: _this.GeneralID,
          User: _this.BUser,
          TableConfig: _this.TableConfig,
          Option: this.option,
        })
          .then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              _this.$emit('init');
              _this.$emit('fatherSetOption', 0);
              _this.Global.request_successful('保存成功!');
            } else {
              _this.Global.request_failure(res.Message);
            }
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err.message,
            });
          });
      }
    },
  },
  mounted() {
    this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
      DeptID: '',
      content: '',
      DeptType: '',
    }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
        this.bumen(this.Classed);

        //this.Classed.push(this.BUser.AcademyID);
      }
    });

    let _this = this;
    let nowYear = new Date().getFullYear() + 1;
    for (let i = 0; i < 10; i++) {
      this.YearList.push(nowYear - i);
    }
    this.$Http_Post('User/GetDicListByDicTypeCode', {
      DicTypeList: 'GradeLevel,Degree,Nation,Nationality,Relative,Student',
    })
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.GradeList = res.Data[0];
          _this.DegreeList = res.Data[1];
          _this.NationList = res.Data[2];
          _this.NationalityList = res.Data[3];
          _this.RelativeList = res.Data[4];
          _this.StudentList = res.Data[5];
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.Global.request_failure(res.Message);
      });
    // this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd').then((res) => {
    //   if (res.Code == 200 || res.Code == 0 && res.Data) {
    //
    //     _this.DeptData = res.Data;
    //   }
    // });
  },
};
</script>
<style>
.Single-white {
  padding: 10px;
  height: calc(100% - 85px);
  position: relative;
  overflow: auto;
}
</style>
